import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRightIcon, ZapIcon, ShieldCheckIcon, ClockIcon } from 'lucide-react';
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="cta" ref={ref} className="w-full py-16 md:py-24 bg-gradient-to-br from-[#1e3a8a] via-[#1e2a5a] to-[#1e3a8a]" data-id="element-10">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-5xl" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="space-y-10 text-center" data-id="element-12">
          <div className="space-y-6" data-id="element-13">
            

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight" data-id="element-14">
              Comienza a Generar Ventas{' '}
              <span className="text-[#f97316]" data-id="element-15">en las Próximas 48 Horas</span>
            </h2>

            <p className="text-xl md:text-2xl text-[#faf8f5] max-w-3xl mx-auto leading-relaxed" data-id="element-16">
              No esperes más. Cada día sin ventas es un día perdido. Toma acción
              ahora y transforma tu negocio.
            </p>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: 0.4,
          duration: 0.5
        }} className="space-y-6" data-id="element-17">
            <div className="flex flex-col items-center gap-2" data-id="element-18">
              <div className="flex items-baseline justify-center gap-3" data-id="element-19">
                <span className="text-2xl md:text-3xl text-[#faf8f5]/60 line-through font-medium" data-id="element-20">
                  $27
                </span>
                <span className="text-5xl md:text-6xl font-extrabold text-white" data-id="element-21">
                  $6.39
                </span>
              </div>
              <span className="inline-block bg-[#f97316] text-white text-sm md:text-base font-bold px-4 py-1 rounded-full uppercase tracking-wide" data-id="element-22">
                Oferta por tiempo limitado
              </span>
            </div>

            <a href="https://marketingconsabordigital.com/cart/57941978841391:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-4 bg-[#f97316] hover:bg-[#ea580c] text-white font-bold text-xl md:text-2xl px-12 py-6 rounded-lg shadow-2xl hover:shadow-[#f97316]/50 transition-all duration-300 hover:scale-105" data-id="element-23">
              OBTENER ACCESO INMEDIATO POR $6.39
              <ArrowRightIcon className="w-7 h-7" data-id="element-24" />
            </a>

            <div className="flex flex-wrap justify-center gap-6 text-[#faf8f5]" data-id="element-25">
              <div className="flex items-center gap-2" data-id="element-26">
                <ClockIcon className="w-5 h-5 text-[#f97316]" data-id="element-27" />
                <span className="font-medium" data-id="element-28">Acceso instantáneo</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-29">
                <ShieldCheckIcon className="w-5 h-5 text-[#f97316]" data-id="element-30" />
                <span className="font-medium" data-id="element-31">Garantía de satisfacción</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-32">
                <ZapIcon className="w-5 h-5 text-[#f97316]" data-id="element-33" />
                <span className="font-medium" data-id="element-34">Resultados en 48 horas</span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={isInView ? {
          opacity: 1
        } : {}} transition={{
          delay: 0.6,
          duration: 0.5
        }} className="border-t border-white/20 pt-8" data-id="element-35">
            <p className="text-lg text-[#faf8f5]/80 italic" data-id="element-36">
              "La diferencia entre soñar con un negocio y tener un negocio real
              es una sola cosa: la primera venta."
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}